import { toCamelCase } from './toCamelCase.js';
import { removeNonAlphanumeric } from './removeNonAlphanumeric.js';

const removeNumbersFromBeginning = (input) => input.replace(/^\d+/, '');
const replaceSlashAndUnderScore = (input) => input.replace('-', ' ').replace('_', ' ');

export const generateObjectSlug = (input) => {
  const noNums = removeNumbersFromBeginning(String(input).trim());
  const noSlashUnderscore = replaceSlashAndUnderScore(noNums);
  const noAlphanum = removeNonAlphanumeric(noSlashUnderscore).trim();

  return toCamelCase(noAlphanum);
};
